import React, { Component } from 'react';

import AboutImg from './../../img/hero-portfolio.jpg'
import Webdesign29Logo from './../../img/partners/webdesign29-logo-white.png'
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {toggleDarkMode} from "../../actions/preferenceActions";

class AboutComponent extends Component {
    render() {
        let { _preferences: preferences } = this.props;

        return(
            <>
                {/* Start About Area */}
                <section className="about-area section-gap">
                    <div className="container">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-lg-6 about-left">
                                <img className="img-fluid" src={ AboutImg } alt="Ahmed Karim, développeur" loading="lazy" />
                            </div>
                            <div className="col-lg-5 col-md-12 about-right">
                                <div className="section-title">
                                    <h2>À Propos</h2>
                                </div>
                                <div className="mb-50 wow fadeIn" data-wow-duration=".8s">
                                    <p>
                                        Je m'appelle <b>{ preferences._author }</b>, j'ai {(new Date()).getFullYear() - preferences._year_old} ans et je suis développeur web et logiciel.
                                        <br/>
                                        Après mon <b>BTS SIO</b> (Brevet de Technicien Supérieur Services Informatiques aux Organisations) en option <b>SLAM</b> (Solutions
                                        Logicielles et Applications Métiers), j'ai validé un <b>Bachelor Concepteur Développeur d'Applications</b> au CESI de Brest.
                                        <br/>
                                        <br/>
                                        Je termine en octobre 2026 le mastère <b>Manager en Architecture et Applications Logicielles des SI</b>, toujours au CESI.
                                        <br/>
                                        <br/>
                                        En parallèle, cela fait trois ans que je suis en alternance chez <b>Webdesign29</b>, à Brest. J'y développe aujourd'hui <b>Inklura</b>,
                                        une super-app de gestion qui réunit 13 modules métier (CRM, projets, finances, e-commerce), en TypeScript, React et NextJS.
                                    </p>

                                    <p className="text-muted">
                                        L'informatique m'intéresse depuis très longtemps. Je voulais comprendre comment fonctionnaient les objets technologiques autour de moi,
                                        mais cette passion pour la programmation informatique a vraiment commencé quand j'ai suivi mon premier tuto sur le site <b>SiteDuZero</b>, devenu
                                        après <b><a target="_blank" rel="noopener noreferrer" href="https://openclassrooms.com/fr/">OpenClassrooms</a></b>.
                                    </p>
                                </div>
                                <div className="about-actions wow fadeIn" data-wow-duration=".8s" data-wow-delay=".1s">
                                    <Link to="/about" className="primary-btn white" data-text="Plus d'Info">
                                        { "Plus".split("").map((rows, keys) => <span key={ keys }>{ rows }</span>) }
                                    </Link>

                                    <a
                                        href="https://webdesign29.net/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="current-company-card"
                                        aria-label="Voir le site de Webdesign29"
                                    >
                                        <span className="company-card-logo">
                                            <img src={ Webdesign29Logo } alt="" />
                                        </span>
                                        <span className="company-card-content">
                                            <span>Actuellement</span>
                                            <strong>Webdesign29, Brest</strong>
                                        </span>
                                        <span className="company-card-link lnr lnr-arrow-right"></span>
                                    </a>
                                </div>
                                {/*<Link to="/about" className="primary-btn" data-text="Resume">
                                    { "Resume".split("").map((rows, keys) => <span key={ keys }>{ rows }</span>) }
                                </Link>*/}
                            </div>
                        </div>
                    </div>
                </section>
                {/* End About Area */}
            </>
        );

    }
}

AboutComponent.protoType = {
    _preferences: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    _preferences: state._preferences
});

export default connect(
  mapStateToProps,
  { toggleDarkMode }
)(AboutComponent);
